<template>
  <div>
    <form
      ref="form"
      data-url="/accreditations/process/documentaryEvaluation/updateCustom403"
      :class="{ 'loading-opacity': preloader }"
      enctype="multipart/form-data"
    >
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col">NOMBRE</th>
            <th scope="col" class="align-middle text-center" style="width: 25%">
              USUARIO
            </th>
            <th scope="col" class="text-center" style="width: 15%">
              FECHA DE CREACIÓN
            </th>
            <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="evalTest.file_evaluation">
            <td class="align-middle">Propuesta del Equipo Evaluador</td>
            <td class="align-middle text-center">
              {{
                evalTest.file_evaluation.user
                  ? `${evalTest.file_evaluation.user.first_name} ${evalTest.file_evaluation.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ evalTest.file_evaluation.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(evalTest.file_evaluation.path)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
          <!-- <tr v-if="evalTest.sampling_plan_file">
          <td class="align-middle">Plan de Muestreo</td>
          <td class="align-middle">
            {{ evalTest.sampling_plan_file.created_at | dateFormat }}
          </td>
          <td class="align-middle text-center">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(evalTest, 'sampling_plan_file')"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>
          </td>
        </tr> -->
          <tr v-if="evalTest.report_documentary_evaluation">
            <td class="align-middle">Informe de Evaluación Documental</td>
            <td class="align-middle text-center">
              {{
                evalTest.report_documentary_evaluation.user
                  ? `${evalTest.report_documentary_evaluation.user.first_name} ${evalTest.report_documentary_evaluation.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{
                evalTest.report_documentary_evaluation.created_at | dateFormat
              }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="
                  openTab(evalTest.report_documentary_evaluation.path)
                "
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="evalTest.scope401">
            <td class="align-middle">Alcances</td>
            <td class="align-middle text-center">
              {{
                evalTest.scope401.user
                  ? `${evalTest.scope401.user.first_name} ${evalTest.scope401.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ evalTest.scope401.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(evalTest.scope401.path)"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="evalTest.first_instance_finding403">
            <td class="align-middle">
              Primera entrega informe para el cierre de hallazgos y decisión
            </td>
            <td class="align-middle text-center">
              {{
                evalTest.first_instance_finding403.user
                  ? `${evalTest.first_instance_finding403.user.first_name} ${evalTest.first_instance_finding403.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ evalTest.first_instance_finding403.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="
                  openTab(evalTest.first_instance_finding403.path)
                "
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <tr v-if="evalTest.request_additional_evidence">
            <td class="align-middle">Solicitud de Evidencias Adicionales</td>
            <td class="align-middle text-center">
              {{
                evalTest.request_additional_evidence.user
                  ? `${evalTest.request_additional_evidence.user.first_name} ${evalTest.request_additional_evidence.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ evalTest.request_additional_evidence.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="
                  openTab(evalTest.request_additional_evidence.path)
                "
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>

          <!-- <tr v-if="evalTest.request_additional_evidence_2">
          <td class="align-middle">
            Segunda Solicitud de Evidencias Adicionales
          </td>
          <td class="align-middle text-center">
            {{
              evalTest.request_additional_evidence_2.user
                ? `${evalTest.request_additional_evidence_2.user.first_name} ${evalTest.request_additional_evidence_2.user.last_name}`
                : ""
            }}
          </td>
          <td class="align-middle text-center">
            {{ evalTest.request_additional_evidence_2.created_at | dateFormat }}
          </td>
          <td class="align-middle text-center">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="
                openTab(evalTest.request_additional_evidence_2.path)
              "
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>
          </td>
        </tr> -->

          <tr v-if="evalTest.second_instance_finding403">
            <td class="align-middle">
              Segunda entrega informe para el cierre de hallazgos y decisión
            </td>
            <td class="align-middle text-center">
              {{
                evalTest.second_instance_finding403.user
                  ? `${evalTest.second_instance_finding403.user.first_name} ${evalTest.second_instance_finding403.user.last_name}`
                  : ""
              }}
            </td>
            <td class="align-middle text-center">
              {{ evalTest.second_instance_finding403.created_at | dateFormat }}
            </td>
            <td class="align-middle text-center">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="
                  openTab(evalTest.second_instance_finding403.path)
                "
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="col-12">
          <app-note
            class="mb-primary"
            :show-title="false"
            :notes="['Todos los campos con un (*) son obligatorios.']"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <legend>
            <p class="text-primary">Documentación primera entrega</p>
          </legend>
          <div class="form-group">
            <label
              >Informe para el cierre de hallazgos y decisión:<b
                class="text-danger ml-2"
                style="font-size: 18px !important"
                >*</b
              ></label
            >
            <app-input
              type="file"
              :label="
                inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')
              "
              v-model="inputs.file_1"
              :required="true"
              v-if="!inputs.first_instance_finding403"
            />
            <div class="mt-2">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(inputs.first_instance_finding403.path)"
                v-if="inputs.first_instance_finding403"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>

              <button
                type="submit"
                class="btn btn-danger"
                @click.prevent="openDeleteModal('first_instance_finding403')"
                v-if="inputs.first_instance_finding403 && rejectCounter == 0"
              >
                <app-icon name="trash-2" />
                {{ $t("delete") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <legend class="text-primary">
            Respaldo gestión de No Conformidades primera entrega
          </legend>
          <div class="card-body" v-if="rejectCounter == 0">
            <div class="form-group">
              <app-input type="dropzone" v-model="files_1" />
              <p class="text-center text-danger mt-2">
                <small>
                  <strong>Tamaño máximo de cada archivo 8MB</strong>
                </small>
              </p>
            </div>
          </div>
          <table class="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th scope="col">Nombre del documento</th>
                <th scope="col" class="text-center" style="width: 10%">
                  Opciones
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(
                  value, key
                ) in inputs.support_management_non_conformities_403_1"
                :key="key"
              >
                <td class="align-middle">
                  <small class="text-primary">{{
                    value.path.split("/")[value.path.split("/").length - 1]
                  }}</small>
                </td>
                <td class="align-middle text-center">
                  <div class="mt-2">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value.path)"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-if="rejectCounter == 1">
        <div class="col-sm-8">
          <legend>
            <p class="text-primary">Documentación segunda entrega</p>
          </legend>
          <div class="form-group">
            <label
              >Informe para el cierre de hallazgos y decisión:<b
                class="text-danger ml-2"
                style="font-size: 18px !important"
                >*</b
              ></label
            >
            <app-input
              type="file"
              :label="
                inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')
              "
              v-model="inputs.file_2"
              :required="true"
              v-if="!inputs.second_instance_finding403"
            />
            <div class="mt-2">
              <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openTab(inputs.second_instance_finding403.path)"
                v-if="inputs.second_instance_finding403"
              >
                <app-icon name="file" />
                {{ $t("view") }}
              </button>

              <button
                type="submit"
                class="btn btn-danger"
                @click.prevent="openDeleteModal('second_instance_finding403')"
                v-if="inputs.second_instance_finding403"
              >
                <app-icon name="trash-2" />
                {{ $t("delete") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2" v-if="rejectCounter == 1">
        <div class="col-12">
          <legend class="text-primary">
            Respaldo gestion de No Conformidades segunda entrega
          </legend>
          <div class="card-body">
            <div class="form-group">
              <app-input type="dropzone" v-model="files_2" />
              <p class="text-center text-danger mt-2">
                <small>
                  <strong>Tamaño máximo de cada archivo 8MB</strong>
                </small>
              </p>
            </div>
          </div>
          <table class="table table-sm table-striped mt-2">
            <thead>
              <tr>
                <th scope="col">Nombre del documento</th>
                <th scope="col" class="text-center" style="width: 10%">
                  Opciones
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(
                  value, key
                ) in inputs.support_management_non_conformities_403_2"
                :key="key"
              >
                <td class="align-middle">
                  <small class="text-primary">{{
                    value.path.split("/")[value.path.split("/").length - 1]
                  }}</small>
                </td>
                <td class="align-middle text-center">
                  <div class="mt-2">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(value.path)"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mt-3">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
        <br />
        <hr />
      </div>

      <app-confirmation-modal
        v-if="deleteModal"
        modal-id="delete"
        @confirmed="confirmed"
        @cancelled="cancelled"
        title="Confirmación"
        message="¿Desea eliminar este archivo?"
      />
    </form>

    <!-- <div class="row">
      <div class="col-12">
        <legend>
          <small class="text-primary"
            >Respaldo gestión de No Conformidades primera entrega</small
          >
        </legend>
      </div>
      <div class="col-12">
        <div
          class="row mb-2"
          v-for="(vj, j) in inputs.support_management_non_conformities_403_1"
          :key="j"
        >
          <div class="col-12 col-md-5" v-if="!vj.annexed">
            <app-input
              :id="`file_${j}`"
              type="file"
              :label="vj.file ? vj.file.name : $t('upload_your_file')"
              v-model="vj.file"
              @change="onChange($event, j)"
            />
            <small v-if="!vj.annexed" class="text-center text-danger"
              >Tamaño máximo del archivo 8 Mb</small
            >
          </div>

          <div class="col-12 col-md-6" v-if="vj.annexed">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openFileTab(vj.annexed)"
            >
              <app-icon name="file" /> Ver
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal(j, vj)"
            >
              <app-icon name="trash-2" /> Eliminar
            </button>
          </div>

          <div class="col-12 col-md-5" v-if="vj.annexed">
            <app-input
              :id="`filename_${j}`"
              type="text"
              v-model="vj.filename"
              placeholder="Descripcion del archivo"
              @keyup="onKeyUp(j)"
            />
            <small v-if="!vj.filename" class="text-center text-danger"
              >Es necesario agregar una descripción</small
            >
          </div>

          <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
            <button
              type="submit"
              class="btn btn-warning"
              @click="removeRowFile(j)"
              v-if="!vj.annexed"
            >
              Quitar
            </button>
          </div>
        </div>
        <div class="row mt-2" v-if="rejectCounter == 0" >
          <div class="col-12">
            <button type="submit" class="btn btn-primary" @click="addFile()">
              <app-icon name="plus" /> Agregar archivo
            </button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import {
  axiosDelete,
  axiosPost,
} from "../../../../../../../../../../resources/js/app/helpers/AxiosHelper";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {
        support_management_non_conformities_403_1: [],
        support_management_non_conformities_403_2: [],
      },
      files_1: [],
      files_2: [],
      deleteModal: false,
      selected: "",
      observation: "",
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
    rejectCounter() {
      return this.evalTest
        ? this.evalTest.corrective_actions_reject_counter
        : 0;
    },
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
    files: function (files) {},
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.loadForm();
  },

  methods: {
    /* addFile() {
      if (this.inputs.support_management_non_conformities_403_1.length >= 15) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 15 archivos");
        return;
      }
      this.inputs.support_management_non_conformities_403_1.push({
        record_id: this.$store.state.evaluatorReview.evalTest.id,
        filename: null,
        file: null,
      });
      console.log(this.inputs.support_management_non_conformities_403_1);
    },

    openFileTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModal(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    removeRowFile(j) {
      this.inputs.support_management_non_conformities_403_1 =
        this.inputs.support_management_non_conformities_403_1.filter(
          (value, index) => index != j
        );
    },

    cancelled() {
      this.deleteModal = false;
    },

    onChange(e, j) {
      const tmp = this.inputs.support_management_non_conformities_403_1[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(
          this.inputs.support_management_non_conformities_403_1[j],
          "file",
          null
        );
        this.$set(
          this.inputs.support_management_non_conformities_403_1[j],
          "filename",
          null
        );
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }
      if (!tmp.filename)
        this.$set(
          this.inputs.support_management_non_conformities_403_1[j],
          "filename",
          "Respaldo gestión de No Conformidades primera entrega " + (j+1)
        );
      this.chargeFile(j);
    },

    onKeyUp(j) {
      const tmp = this.inputs.support_management_non_conformities_403_1[j];
      if (!tmp.annexed) {
      } else {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
      }
    },

    removeRowFile(j) {
      this.inputs.support_management_non_conformities_403_1 =
        this.inputs.support_management_non_conformities_403_1.filter(
          (value, index) => index != j
        );
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `/accreditations/process/documentaryEvaluation/addFileFirst`;
      const tmpo = this.inputs.support_management_non_conformities_403_1[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(
        this.inputs.support_management_non_conformities_403_1[j]
      )) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
        .then((res) => {
          this.deleteLoader = false;
          if (tmpo.file) {
            const data = res.data.data[res.data.data.length - 1];
            const tmp = [
              ...this.inputs.support_management_non_conformities_403_1,
            ];
            tmp[j] = data;
            this.inputs.support_management_non_conformities_403_1 = tmp;
          }
        })
        .catch(({ error }) => {});
    },

    confirm() {
      const url = `/accreditations/process/documentaryEvaluation/destroyFileFirst?eval_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}&type=${this.tmp.vj.type}`;
      axiosDelete(url)
        .then((res) => {
          this.deleteModal = false;
          this.deleteLoader = false;
          const { data } = res.data.data;
          if (
            this.tmp.vj.type ==
            "inputs.support_management_non_conformities_403_1"
          ) {
            const tmp =
              this.inputs.support_management_non_conformities_403_1.filter(
                (value, index) => index != this.tmp.j
              );
            this.inputs.support_management_non_conformities_403_1 = tmp;
          }
        })
        .catch(({ error }) => {});
    }, */
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      if (this.files_1.length > 0 && this.validateFileSize(this.files_1) > 0) {
        this.$toastr.e("El tamaño maximo permitido de cada archivo es de 8MB");
        return;
      }

      if (this.files_2.length > 0 && this.validateFileSize(this.files_2) > 0) {
        this.$toastr.e("El tamaño maximo permitido de cada archivo es de 8MB");
        return;
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }

      this.files_1.forEach((file) => {
        formData.append("files_1[]", file);
      });

      this.files_2.forEach((file) => {
        formData.append("files_2[]", file);
      });

      this.save(formData);
    },
    afterSuccess({ data: { data } }) {
      this.files_1 = [];
      this.files_2 = [];
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },
    confirmed() {
      this.inputs[this.selected] = null;
    },
    observationList() {},
    cancelled() {
      this.deleteModal = false;
    },
    openTab(path) {
      const w = window.open(path, "_blank");
      w.focus();
    },
    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          second_instance_finding403:
            this.$store.state.evaluatorReview.evalTest
              .second_instance_finding403,
          first_instance_finding403:
            this.$store.state.evaluatorReview.evalTest
              .first_instance_finding403,
          support_management_non_conformities_403_1:
            this.$store.state.evaluatorReview.evalTest
              .support_management_non_conformities_403_1,
          support_management_non_conformities_403_2:
            this.$store.state.evaluatorReview.evalTest
              .support_management_non_conformities_403_2,
        };
      }
    },
    validateFileSize(files) {
      return files.filter((file) => {
        if (file.size > 8000000) {
          return file;
        }
      }).length;
    },
  },
};
</script>